import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarcode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBarcode"><Path d="M7.5 4.5H2.5V9.67241M16.5 4.5H21.5V9.67241M21.5 14.3276V19.5H16.5M7.63514 19.5L2.5 19.5V14.3276M7.5 9.5V14.5M16.5 9.5V14.5M12 9.5V12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBarcode;
